import { TextFieldProps } from "@mui/material";
import { useCallback } from "react";
import FormTextField from "./FormTextField";
import { TextStyleProps } from "../types/formConfig";

interface FormCurrencyFieldProps extends Omit<TextFieldProps, 'value' | 'onChange' | 'sx' | 'type'> {
    fieldPath: string;
    value: any;
    handleFieldChange: (fieldPath: string, value: any) => void;
    isImportant: boolean;
    getFieldConfidence?: (fieldPath: string) => number;
    currentExtraction?: any;
    width?: number | string;
    negativeOnly?: boolean;
    labelStyle?: TextStyleProps;
    inputStyle?: TextStyleProps;
    indexLabel?: string;
}

/**
 * Currency field that extends FormTextField with number-specific functionality
 */
const FormCurrencyField = ({
    fieldPath,
    value,
    handleFieldChange,
    isImportant,
    getFieldConfidence,
    currentExtraction,
    width,
    negativeOnly,
    labelStyle,
    inputStyle,
    indexLabel,
    ...textFieldProps
}: FormCurrencyFieldProps) => {
    const handleBlur = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
        if (negativeOnly) {
            const num = Number(e.target.value);
            if (!Number.isNaN(num) && num > 0) {
                handleFieldChange(fieldPath, -num);
            }
        }
    }, [negativeOnly, fieldPath, handleFieldChange]);

    return (
        <FormTextField
            fieldPath={fieldPath}
            value={value}
            handleFieldChange={handleFieldChange}
            isImportant={isImportant}
            getFieldConfidence={getFieldConfidence}
            currentExtraction={currentExtraction}
            width={width}
            type="number"
            onBlur={negativeOnly ? handleBlur : undefined}
            labelStyle={labelStyle}
            inputStyle={inputStyle}
            indexLabel={indexLabel}
            {...textFieldProps}
        />
    );
};

export default FormCurrencyField;
